export const getPageName = (pathname) => {
  const path = pathname.split('/')

  if (path.length > 1) {
    return path[1]
  }
  return null
}
